<!-- The one card. Factory-owned. Styles in kit.css.

     A titled block of content on the page ground. Never nest one in another,
     and never use a grid of identical cards as a screen's structure — a list of
     things is a list (`ListRow`), not a wall of cards. -->
<template>
  <section class="kit-card" :aria-labelledby="title ? headingId : undefined">
    <h2 v-if="title" :id="headingId" class="kit-card__title">{{ title }}</h2>
    <p v-if="body" class="kit-card__body">{{ body }}</p>
    <slot />
  </section>
</template>

<script setup>
import { useId } from 'vue';

defineProps({
  title: { type: String, default: '' },
  body: { type: String, default: '' },
});

const headingId = `kit-card-${useId()}`;
</script>
